import DetailFleetIssue from "../../../components/FleetIssues/EditFleetIssues";

const FleetIssueEditPage = () => {
  return (
      <DetailFleetIssue/>
  );
};

export default FleetIssueEditPage;
